/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import * as Types from '@r-client/data/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type ILiveSectorTagsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ILiveSectorTagsQuery = {
  __typename?: 'Query';
  tags: {
    __typename?: 'TagsTagConnection';
    totalCount: number;
    nodes: Array<{
      __typename?: 'TagsTag';
      id: string;
      slug: string;
      displayName: string;
    }>;
  };
};

export const LiveSectorTagsDocument = gql`
  query LiveSectorTags {
    tags(parents: ["sector"], withLiveDeals: true, order: [DISPLAY_NAME_ASC]) {
      totalCount
      nodes {
        id
        slug
        displayName
      }
    }
  }
`;
export type LiveSectorTagsQueryResult = Apollo.QueryResult<
  ILiveSectorTagsQuery,
  ILiveSectorTagsQueryVariables
>;
